exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu-icon-image[data-v-14856c20]{\n  margin-left: 660px;\n}\n.menu-dine-image[data-v-14856c20]{\n    margin-left: 500px;\n}\n", ""]);

// exports
